import React, { memo } from 'react';
import _get from 'lodash/get';

// Component
import CategoryCard from './CategoryCard';
import useEntityTypes from 'helpers/useEntityTypes';

function Container(props) {
  const { typeKey } = props;
  const entityTypes = useEntityTypes();
  const entityType = _get(entityTypes, typeKey);

  const globalTempValue = {
    name: '',
    type: '',
    value: {
      id: '',
      displayName: '',
      entityField: '',
      children: [],
    },
  };

  return (
    <CategoryCard
      typeKey={typeKey}
      entityType={entityType}
      attributeTempValue={globalTempValue}
      {...props}
    />
  );
}

export default memo(Container);
